'use client'

import { Button, cn } from "@heroui/react"
import { useTheme } from "next-themes"
import { useTranslations } from "next-intl"
import { useEffect, useState } from "react"

const SunIcon = (props: any) => (
  <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}>
    <circle cx="12" cy="12" r="4" />
    <path d="M12 2v2M12 20v2M4.93 4.93l1.41 1.41M17.66 17.66l1.41 1.41M2 12h2M20 12h2M6.34 17.66l-1.41 1.41M19.07 4.93l-1.41 1.41" />
  </svg>
)

const MoonIcon = (props: any) => (
  <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}>
    <path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z" />
  </svg>
)

const SystemIcon = (props: any) => (
  <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}>
    <rect x="2" y="3" width="20" height="14" rx="2" />
    <path d="M8 21h8M12 17v4" />
  </svg>
)

// 循环顺序：浅色 → 暗色 → 跟随系统
const ORDER = ["light", "dark", "system"] as const

export const ThemeToggle = ({ className }: { className?: string }) => {
  const { theme, setTheme } = useTheme()
  const t = useTranslations("theme")
  const [mounted, setMounted] = useState(false)

  // 避免 SSR/CSR 主题不一致导致的 hydration 警告
  useEffect(() => setMounted(true), [])

  const current = (theme && (ORDER as readonly string[]).includes(theme) ? theme : "system") as (typeof ORDER)[number]

  const next = () => {
    const idx = ORDER.indexOf(current)
    setTheme(ORDER[(idx + 1) % ORDER.length])
  }

  const renderIcon = () => {
    if (current === "light") return <SunIcon />
    if (current === "dark") return <MoonIcon />
    return <SystemIcon />
  }

  const label = mounted ? `${t("label")}: ${t(current)}` : "Toggle theme"

  return (
    <Button
      isIconOnly
      aria-label={label}
      title={mounted ? label : undefined}
      radius="full"
      className={cn("h-9 w-9 min-w-0 sm:h-10 sm:w-10 bg-gray-bg text-theme-primary flex-shrink-0", className)}
      onPress={next}
    >
      {mounted ? renderIcon() : <MoonIcon style={{ opacity: 0 }} />}
    </Button>
  )
}

export default ThemeToggle
